export const PINNED_COMPANIES_KEY = 'pinnedCompanies';
export const PINNED_FUND_INVESTMENTS_KEY = 'pinnedFundInvestments';
export const PINNED_FUNDS_KEY = 'pinnedFunds';
export const PINNED_FIRMS_KEY = 'pinnedFirms';
